/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const Permissions = (
	<SVG
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 20"
		fill="none"
		className="pum-icon pum-icon--permissions"
	>
		<Path
			d="M14.2 19C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V5.8C19 4.11984 19 3.27977 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1L5.8 1C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8L1 14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19H14.2Z"
			stroke="#000000"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<Path
			d="M11.7316 11.1947C11.661 10.9831 11.6257 10.8772 11.6276 10.7907C11.6295 10.6996 11.6417 10.6519 11.6836 10.5711C11.7235 10.4942 11.83 10.395 12.0432 10.1967C12.6318 9.64895 13 8.86747 13 8C13 6.34315 11.6569 5 10 5C8.34315 5 7 6.34315 7 8C7 8.86747 7.36818 9.64895 7.95681 10.1967C8.16996 10.395 8.27653 10.4942 8.31639 10.5711C8.35832 10.6519 8.37049 10.6996 8.37242 10.7907C8.37426 10.8772 8.33898 10.9831 8.26844 11.1947L7.35099 13.947C7.23249 14.3025 7.17324 14.4803 7.20877 14.6218C7.23987 14.7456 7.31718 14.8529 7.42484 14.9216C7.54783 15 7.7352 15 8.10994 15H11.8901C12.2648 15 12.4522 15 12.5752 14.9216C12.6828 14.8529 12.7601 14.7456 12.7912 14.6218C12.8268 14.4803 12.7675 14.3025 12.649 13.947L11.7316 11.1947Z"
			stroke="#000000"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</SVG>
);

export default Permissions;
